import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/', '/home', '/register', '/login', '/auth-redirect', '/404', '/401', '/lock', '/reset-password']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // 进度条
  const sysConfig = store.getters.sysConfig
  if (sysConfig === undefined || Object.keys(sysConfig).length === 0) {
    store.dispatch('GetSysConfig').then(res => {}).catch(() => {
      Message.error('获取系统配置失败！')
    })
  }

  if (to.path.indexOf('/mobile') !== -1) {
    next()
  }else if(getAiTokenLogin(next)){
    // next()
  } else if (getToken()) { // 判断是否已登录
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      const userInfo = store.getters.userInfo;
      if (Object.keys(userInfo).length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            console.log(err,"err")
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
    NProgress.done()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done();
  if(store.getters.userInfo&&store.getters.userInfo.userId ){
    document.title = store.getters.userInfo.tenantName + "信息素养库"
  }else{
    document.title = "中文在线高校信息素养库";
  }
})


// ai自习室单点登录
function getAiTokenLogin(next){
  // 判断url是否携带token - 同时检查search和hash中的token
    // 1. 从search部分获取token
    const searchToken = router.currentRoute.query.token
    // 2. 从hash部分获取token
    let hashToken = null
    const hash = window.location.hash
    if (hash) {
      const hashParams = new URLSearchParams(hash.split('?')[1] || '')
      hashToken = hashParams.get('token')
    }
    // 3. 使用存在的token（优先使用search中的token）
    const token = searchToken || hashToken
    console.log('获取到的token1222:', token);
    if(token){
      store.commit("SET_TOKEN", token);
      store.dispatch("GetUserInfo").then(res => { // 拉取user_info
        next() // hack方法 确保addRoutes已完成
      }).catch((err) => {
        next({ path: '/' })
      })
      return true
    }
    return false
}


// WEBPACK FOOTER //
// ./src/permission.js